import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Company } from "../../models";
import { getCompanies } from "../../api";
import { useShowAllCompanies } from "../../hooks/useShowAllCompanies";
import { useCurrentUser } from "../../hooks/useCurrentUser";

interface PersonaCompanySelectProps {
  value: number | null | undefined;
  onChange: (companyId: number | null) => void;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
}

// Lists the user's companies, or every company when an admin has "Show all companies" on.
// Only admins viewing all companies can leave a persona unassigned.
export const PersonaCompanySelect: React.FC<PersonaCompanySelectProps> = ({ value, onChange, style, className, disabled }) => {
  const user = useCurrentUser();
  const [showAll] = useShowAllCompanies();
  const [companies, setCompanies] = useState<Company[]>([]);

  const canUnassign = Boolean(user?.perms.admin) && showAll;

  useEffect(() => {
    getCompanies(showAll)
      .then(setCompanies)
      .catch(e => console.error(e));
  }, [showAll]);

  // Keep showing the current company even if it isn't in the loaded list
  const options = value && !companies.some(c => c.id === value)
    ? [...companies, { id: value, name: `Company ${value}`, status: "active" } as Company]
    : companies;

  return (
    <FormControl style={style} className={className} variant="outlined" disabled={disabled}>
      <InputLabel>Company</InputLabel>
      <Select
        label="Company"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
      >
        {(canUnassign || !value) && <MenuItem value="" disabled={!canUnassign}><em>Unassigned</em></MenuItem>}
        {options.map(company => (
          <MenuItem key={company.id} value={company.id}>{company.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
